/* eslint-disable */

import EVENTS from '@/utils/Constants/Events';
import GTM from '@/utils/Controllers/GTM/Constants';
import CONST from '@/utils/Constants/General';
import { isTrue } from '@/utils/Common/Booleans';
import { stopper } from '@/search/Controllers/SearchBackToPlpController';

const observerConfig = { rootMargin: '0px 0px 400px 0px' };

const updatePagination = (nextPage, gtmEvent) => {
  DLG.EVE.emit(EVENTS.SEARCH.RESULTS.PAGINATION, { nextPage, gtmEvent });
};

const loadMoreClickHandler = e => {
  const { nextPage } = e.currentTarget.dataset;
  updatePagination(nextPage, GTM.EVENT.LISTING_IMPRESSION_LOAD_MORE);
};

const loadMoreResults = searchType => {
  const el = document.querySelector(
    `#js-search-service-load-more${
      searchType ? `[data-search-type='${searchType}']` : ''
    }`,
  );
  if (el) {
    el.addEventListener('click', loadMoreClickHandler);
  }
};

const observerHandler = entries => {
  const entry = entries[0];
  const { nextPage, searchType } = entry.target.dataset;
  const gtmEvent = CONST.SEARCH.TYPE.PRODUCT === searchType ? '' : null;
  if (entry.isIntersecting && !stopper) {
    updatePagination(nextPage, gtmEvent);
  }
};

const saveCoords = targetProduct => {
  const element = document.getElementById(`prod-id-${targetProduct}`);
  const attribute = element.getAttribute('data-pagination');
  sessionStorage.setItem(
    'anchor',
    JSON.stringify({
      page: attribute,
      code: targetProduct,
    }),
  );
};

const infiniteScrollResults = searchType => {
  const uniqueCardValue = document.getElementsByClassName('uniqueProductValue');
  const productCard = document.getElementsByClassName('js-product-tile');
  const inputsValue = [];

  for (let j = 0; j < uniqueCardValue.length; j += 1) {
    inputsValue.push(uniqueCardValue[j].value);
  }

  for (let i = 0; i < productCard.length; i += 1) {
    productCard[i].addEventListener('click', () => {
      saveCoords(inputsValue[i]);
    });
  }

  const el = document.querySelector(
    `#js-search-service-page-limit${
      searchType ? `[data-search-type='${searchType}']` : ''
    }`,
  );
  if (el && !isTrue(el.dataset.hasLoadMore)) {
    const observer = new IntersectionObserver(observerHandler, observerConfig);
    observer.observe(el);
  }
};

export default searchType => {
  infiniteScrollResults(searchType);
  loadMoreResults(searchType);
};
